export const all_routes = {
  dashboard: "/dashboard",
  invoices: "/invoices",
  addInvoice: "/invoice/add-invoice",
  editInvoice: "/invoice/edit-invoice",
  viewInvoice: "/invoice/view-invoice",
  profile: "/profile",
  users: "/users",
  addUser: "/user/add-user",
  editUser: "/user/edit-user",
  auditLogs: "/audit-logs",
  logout: "/logout",
  signin: "/signin",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
};
